import mock from '../mock'

// ** Third Party Components
import axios from 'axios'

// ** Utils
import { paginateArray } from '../utils'

// ** Utils
import { getUserData } from '@utils'

// ** Custom Components
import GetApiCOC from '../../@fake-db/ApiCOC'

const base64ToString = (response) => { 

  if (response.data.Result === "true" && response.data.response_data.length > 0) {
    return JSON.parse(Buffer.from(response.data.response_data, "base64").toString()) 
  } else {
    return []
  }
}

const getkpisConfig = async (dataOrigen, refrescar, api, token, body, config) => {

  const user = getUserData()

  const configws = {
    method: 'get',
    url:    api,
    headers: { 
      Accept:      'application/json',
      obrientoken: token
    },
    params: body
  }

  let data = dataOrigen

  if (data.kpisConfig.length <= 0) {

    const response = await axios(configws)
    data = { kpisConfig: base64ToString(response) }
  }

  // eslint-disable-next-line object-curly-newline
  const { qOffice = '', perPageOffice = 10, pageOffice = 1, sortOfficeA, sortColumnOfficeA, qOfficeUsers = '', perPageOfficeUsers = 10, pageOfficeUsers = 1, sortOfficeUsersA, sortColumnOfficeUsersA } = config
  /* eslint-enable */

  const dataAscOffice = data.kpisConfig.office.sort((a, b) => {
    if (a[sortColumnOfficeA]) {
      return a[sortColumnOfficeA] < b[sortColumnOfficeA] ? -1 : 1
    } else {
      const splitColumn = sortColumnOfficeA.split('.')
      const columnA = a[splitColumn[0]][splitColumn[1]]
      const columnB = b[splitColumn[0]][splitColumn[1]]
      return columnA < columnB ? -1 : 1
    }
  })

  const dataToFilterOffice = sortOfficeA === 'asc' ? dataAscOffice : dataAscOffice.reverse()

  const queryLoweredOffice = qOffice.toLowerCase()

  let filteredDataOffice

  if (user.usercoc.superuser === 1) {
    filteredDataOffice = dataToFilterOffice.filter(kpisConfig => {
        return (
          (
            (kpisConfig.citymax_code && kpisConfig.citymax_code.toLowerCase().includes(queryLoweredOffice))  ||
            (kpisConfig.cluster_name && kpisConfig.cluster_name.toLowerCase().includes(queryLoweredOffice))  ||
            (kpisConfig.country && kpisConfig.country.toLowerCase().includes(queryLoweredOffice))  ||
            (kpisConfig.country_name && kpisConfig.country_name.toLowerCase().includes(queryLoweredOffice))  ||
            (kpisConfig.date_log && kpisConfig.date_log.toLowerCase().includes(queryLoweredOffice))  ||
            (kpisConfig.name && kpisConfig.name.toLowerCase().includes(queryLoweredOffice))  ||
            (kpisConfig.tax && kpisConfig.tax.toLowerCase().includes(queryLoweredOffice))  ||
            (kpisConfig.timezone && kpisConfig.timezone.toLowerCase().includes(queryLoweredOffice)) ||
            (kpisConfig.id && String(kpisConfig.id).toLowerCase().includes(queryLoweredOffice))
          )
        )
    })
  } else {
    const dataFiltradaData = dataToFilterOffice.filter(kpisConfig => { return ((kpisConfig.country === user.office.citymax_code)) })

    filteredDataOffice = dataFiltradaData.filter(kpisConfig => {
      return (
        (
          kpisConfig.citymax_code.toLowerCase().includes(queryLoweredOffice)  ||
          kpisConfig.cluster_name.toLowerCase().includes(queryLoweredOffice)  ||
          kpisConfig.country.toLowerCase().includes(queryLoweredOffice)  ||
          kpisConfig.country_name.toLowerCase().includes(queryLoweredOffice)  ||
          kpisConfig.date_log.toLowerCase().includes(queryLoweredOffice)  ||
          kpisConfig.name.toLowerCase().includes(queryLoweredOffice)  ||
          kpisConfig.tax.toLowerCase().includes(queryLoweredOffice)  ||
          kpisConfig.timezone.toLowerCase().includes(queryLoweredOffice) ||
          String(kpisConfig.id).toLowerCase().includes(queryLoweredOffice)
        )
      )
  })
  }

  const dataAscOfficeUsers = data.kpisConfig.officeusers.sort((a, b) => {
    if (a[sortColumnOfficeUsersA]) {
      return a[sortColumnOfficeUsersA] < b[sortColumnOfficeUsersA] ? -1 : 1
    } else {
      const splitColumn = sortColumnOfficeUsersA.split('.')
      const columnA = a[splitColumn[0]][splitColumn[1]]
      const columnB = b[splitColumn[0]][splitColumn[1]]
      return columnA < columnB ? -1 : 1
    }
  })

  const dataToFilterOfficeUsers = sortOfficeUsersA === 'asc' ? dataAscOfficeUsers : dataAscOfficeUsers.reverse()

  let filteredDataOfficeUsers

  const queryLoweredOfficeUsers = qOfficeUsers.toLowerCase()
  
  if (user.usercoc.superuser === 1) {
    filteredDataOfficeUsers = dataToFilterOfficeUsers.filter(kpisConfig => {
        return (
          (
            kpisConfig.cluster_name.toLowerCase().includes(queryLoweredOfficeUsers) ||
            kpisConfig.country_name.toLowerCase().includes(queryLoweredOfficeUsers) ||
            kpisConfig.first_name.toLowerCase().includes(queryLoweredOfficeUsers) ||
            kpisConfig.last_name.toLowerCase().includes(queryLoweredOfficeUsers) ||
            kpisConfig.office_name.toLowerCase().includes(queryLoweredOfficeUsers) ||
            kpisConfig.cluster_name.toLowerCase().includes(queryLoweredOfficeUsers) ||
            kpisConfig.user_id.toLowerCase().includes(queryLoweredOfficeUsers)

          )
        )
    })
  } else {

    const dataFiltradaData = dataToFilterOfficeUsers.filter(kpisConfig => { return ((kpisConfig.office_name === user.office.name)) })

    filteredDataOfficeUsers = dataFiltradaData.filter(kpisConfig => {
      return (
        (
          kpisConfig.cluster_name.toLowerCase().includes(queryLoweredOfficeUsers) ||
          kpisConfig.country_name.toLowerCase().includes(queryLoweredOfficeUsers) ||
          kpisConfig.first_name.toLowerCase().includes(queryLoweredOfficeUsers) ||
          kpisConfig.last_name.toLowerCase().includes(queryLoweredOfficeUsers) ||
          kpisConfig.office_name.toLowerCase().includes(queryLoweredOfficeUsers) ||
          kpisConfig.cluster_name.toLowerCase().includes(queryLoweredOfficeUsers) ||
          kpisConfig.user_id.toLowerCase().includes(queryLoweredOfficeUsers)

        )
      )
  })
  }

  return [
    200,
    {
      allData: data.kpisConfig,
      totalOffice: filteredDataOffice.length,
      totalOfficeUsers: filteredDataOfficeUsers.length,
      KpisOffice: filteredDataOffice.length <= perPageOffice ? filteredDataOffice : paginateArray(filteredDataOffice, perPageOffice, pageOffice),
      KpisOfficeUsers: filteredDataOfficeUsers.length <= perPageOfficeUsers ? filteredDataOfficeUsers : paginateArray(filteredDataOfficeUsers, perPageOfficeUsers, pageOfficeUsers)
    }
  ]  
}

//----------------------------------------
// GET: Return list if kpisConfig
//----------------------------------------

let datakpisConfig = JSON.parse(localStorage.getItem("datakpisConfig")) || { kpisConfig: []}

mock.onGet('apps/kpisConfig').reply(async config => {

  const user = getUserData()

  if (config.reset) {
    datakpisConfig = { kpisConfig: []}
  }
  
  const user_rol = user.usercoc.role
  const user_superuser  = user.usercoc.superuser

  let body = {}

  if (user_rol === 1 && user_superuser === 0) {
    body = {
      cluster_id:  user.usercoc.cluster,
      office_id:   user.usercoc.office_id,
      country_id:  user.usercoc.country
    }
  }

  const result = await getkpisConfig(datakpisConfig, 1, GetApiCOC('getKpisUsersConfig'), user.token, body, config)
  datakpisConfig = { kpisConfig: result[1].allData }

  localStorage.setItem("datakpisConfig", JSON.stringify(datakpisConfig))

  return result
})

//----------------------------------------
// POST: Add kpisConfig 
//----------------------------------------

mock.onPost(/\/api\/kpisConfig\/\d+/).reply(async config => {
  const body = JSON.parse(config.data)

  const configws = {
    method: 'post',
    url:    GetApiCOC('insertMeeting'),
    headers: { 
      Accept:'application/json'
    },
    params: body
  }

  const response = await axios(configws)

  return [200, response.data]
})